<template>
    <div>
        <b-button
            variant="primary"
            @click.stop="abrirModal()"
            v-if="
                contratacao.permiteAditivar &&
                    !contratacao.temSolicitacaoAditivoPendente &&
                    !contratacao.naoAditivar
            "
            ><i class="fa fa-plus"></i> Solicitar Aditivo</b-button
        >
        <span
            v-if="contratacao.temSolicitacaoAditivoPendente"
            class="d-inline-block pt-2"
            ><strong
                >Existe solicitação de aditivo em processamento</strong
            ></span
        >
        <b-modal v-model="mostrarModal" @show="preencherModal()">
            <div slot="modal-title">
                Solicitação de Aditivo -
                <strong>{{ contratacao.codContratacao }}</strong>
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="
                            $v.novaDataFim.$invalid && $v.novaDataFim.$model
                                ? false
                                : null
                        "
                        invalid-feedback="Nova data de conclusão dever maior ou igual a data de conclusão atual"
                    >
                        <label>Nova data de conclusão</label>
                        <date-picker
                            v-model="novaDataFim"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            @input.native="$v.novaDataFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required"
                            >Quantidade de horas adicionais</label
                        >
                        <b-form-input
                            type="number"
                            v-model="qtdHorasAdicionais"
                            @input="$v.qtdHorasAdicionais.$touch()"
                            :state="$v.qtdHorasAdicionais.$error ? false : null"
                            v-mask="'######'"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            v-if="!$v.qtdHorasAdicionais.required"
                            >A quantidade de horas adicionais é
                            obrigatória</b-form-invalid-feedback
                        >
                        <b-form-invalid-feedback
                            v-if="!$v.qtdHorasAdicionais.qtdHorasPermitida"
                            >A quantidade de horas adicionais dever ser maior ou
                            igual a 0 e menor ou igual a
                            {{ qtdHorasAdicionaisPermitida }}, 25% das horas
                            totais da contratação, conforme regra do
                            SGF.</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                            :rows="4"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Observações</label>
                        <b-form-textarea
                            v-model="observacoes"
                            @input="$v.observacoes.$touch()"
                            :state="$v.observacoes.$error ? false : null"
                            :rows="4"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >As observações são
                            obrigatórias</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    class="ml-2"
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSalvar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        contratacoesServicos: {
            type: Object,
            required: true,
            default: () => ({})
        },

        contratacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            novaDataFim: null,
            qtdHorasAdicionais: 0,
            justificativa: '',
            observacoes: ''
        }
    },

    methods: {
        fecharModal() {
            this.resetForm()
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        },

        preencherModal() {},

        resetForm() {
            this.erros = []
            this.novaDataFim = null
            this.qtdHorasAdicionais = 0
            this.justificativa = ''
            this.observacoes = ''
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarSalvar() {
            let mensagem = `Confirma a solicitação de aditivo para contratação ${this.contratacao.codContratacao}?`
            this.$swal({
                title: 'Solicitação de Aditivo',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')

            let solicitacaoAditivoDto = {
                codContratacao: this.contratacao.codContratacao,
                novaDataFim: this.novaDataFim
                    ? this.$moment(this.novaDataFim, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                qtdHorasAdicionais: this.qtdHorasAdicionais,
                justificativa: this.justificativa,
                observacoes: this.observacoes
            }

            this.contratacoesServicos
                .solicitarAditivo(solicitacaoAditivoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Aditivo solicitado com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                            this.fecharModal()
                        } else {
                            this.$toast.error(
                                'Erro ao solicitar aditivo',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        qtdHorasAdicionaisPermitida() {
            let horas =
                (this.contratacao.cargaHorariaConsultoria +
                    this.contratacao.cargaHorariaInstrutoria) *
                0.25
            return Math.trunc(horas)
        }
    },

    validations: {
        novaDataFim: {
            dataConsistente(value) {
                if (value) {
                    return this.$moment(value, 'DD/MM/YYYY').isSameOrAfter(
                        this.contratacao.dataFim
                    )
                }
                return true
            }
        },
        qtdHorasAdicionais: {
            required,
            qtdHorasPermitida(value) {
                return value >= 0 && value <= this.qtdHorasAdicionaisPermitida
            }
        },
        justificativa: {
            required
        },
        observacoes: {
            required
        }
    }
}
</script>
